/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {send1099BToTaxman} from '../api'

export const useMutationSend1099BToTaxman = createReactQueryMutationHook('send1099BToTaxman', send1099BToTaxman)
